// Aplica um plano do simulador da Claro nos campos de plano/valor da venda (Nova Venda e correção)
export const TIPO_CLARO_PARA_KEY = { HDTV: 'tv', INTERNET: 'internet', FONE: 'fixo', CELULAR: 'movel' };
export const KEY_PARA_TIPO_CRM = { tv: 'TV', internet: 'INTERNET', fixo: 'FIXO', movel: 'MOVEL' };
export const LABEL_KEY = { tv: 'TV', internet: 'Internet', fixo: 'Fixo', movel: 'Móvel' };

const norm = (s) => (s || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Z0-9]+/g, ' ').trim();
const velocidade = (s) => {
  const m = norm(s).match(/(\d+)\s*(MEGA|MB|MBPS|GIGA|GB|GBPS)/);
  if (!m) return null;
  return parseInt(m[1], 10) * (/^G/.test(m[2]) ? 1000 : 1);
};

// Melhor plano do CRM (tabela Valores) para o produto da Claro: mesma velocidade > nome igual > nome contido
export const melhorPlanoCrm = (candidatos, nomeClaro) => {
  const alvo = norm(nomeClaro);
  const vel = velocidade(nomeClaro);
  const fibra = /FIBRA|GPON/.test(alvo);
  if (vel) {
    const mesmaVel = candidatos.filter((p) => velocidade(p.nome_plano) === vel);
    if (mesmaVel.length) return mesmaVel.find((p) => /FIBRA|GPON/.test(norm(p.nome_plano)) === fibra) || mesmaVel[0];
  }
  return candidatos.find((p) => norm(p.nome_plano) === alvo)
    || candidatos.find((p) => { const n = norm(p.nome_plano); return n.length >= 4 && (alvo.includes(n) || n.includes(alvo)); })
    || null;
};

// Retorna o patch de campos para o formulário (plano_{key}_id/nome/valor/qtd) ou null se o tipo não se aplica
export const patchPlanoClaro = ({ produto, preco, tipoCodigo, planosDisponiveis, categoria }) => {
  const key = TIPO_CLARO_PARA_KEY[tipoCodigo];
  if (!key) return null;
  const candidatos = (planosDisponiveis || []).filter((p) => p.tipo === KEY_PARA_TIPO_CRM[key] && p.categoria === categoria);
  const match = melhorPlanoCrm(candidatos, produto.nome);
  const valor = Number(preco?.preco ?? produto.preco_single ?? produto.preco_min ?? 0);
  return {
    key,
    match,
    patch: {
      [`plano_${key}_id`]: match ? match.id : `claro-${produto.id}`,
      [`plano_${key}_nome`]: match ? match.nome_plano : produto.nome,
      [`plano_${key}_valor`]: valor,
      [`plano_${key}_qtd`]: 1,
    },
  };
};
